import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactCodeInput from 'react-code-input'
import _ from 'lodash'
import './styles.scss'
import ErrorModal from '../Modals/error'
import { isMobile } from 'react-device-detect'
import Barcode from '../BarcodeReader/component'
import CommonModal from '../Modals/common'
import BarcodeInfoModal from '../Modals/barcodeinfo'
import { pinInput } from '../../utils'
import history from '../history'
// import { defaultSchedule } from '../../constants/common'

// Direct properties set to ReactCodeInput
const props = {
  className: 'form-control',
  inputStyle: {
    background: 'none',
    border: '0px',
    borderBottom: '2px solid #D6D5D5',
    margin: '0 2px',
    borderRadius: '0px',
    paddingLeft: '0',
    paddingRight: '0',
    textAlign: 'center',
    width: '25px'
  }
}

class RegisterCozy extends Component {
  constructor() {
    super()
    this.state = {
      barcode: '',
      showError: false,
      showInfo: false,
      congrats: false,
      startCamera: true,
      error: '',
      disableNextBtn: false
    }
    this.onBarcodeChange = this.onBarcodeChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.barcodeRead = this.barcodeRead.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.navigate = this.navigate.bind(this)
    this.showInfo = this.showInfo.bind(this)
    this.closeInfo = this.closeInfo.bind(this)
  }

  componentWillMount() {
    const { fetchRooms } = this.props
    //Fetch rooms from the API
    fetchRooms()
  }

  // componentWillReceiveProps({ barcodeSuccess, ...np }) {
  //   if (np.rooms) {
  //     const totalSchedules = np.rooms.reduce((acc, element) => acc + element.length, 0)
  //     if (np.rooms.length > 0 && (np.rooms.length * 7) === totalSchedules) {
  //       this.props.history.push('/home')
  //     }
  //   }
  //   const { setSchedule, rooms, setScheduleSuccess } = np
  //   if (barcodeSuccess !== this.props.barcodeSuccess) {
  //     if (barcodeSuccess.errors) {
  //       this.setState({ showError: true })
  //     } else {
  //       // fetchRooms()
  //       // Get first room from the response and store to local storage to manage room value correct while coming from the copy screen
  //       const roomId = _.get(barcodeSuccess, 'data.assumeControl.rooms[0].id', false)
  //       if (roomId) {
  //         localStorage.setItem('room', roomId)
  //       } else {
  //         // this.setState({ showError: true })
  //       }
  //     }
  //   }
  //   if (setScheduleSuccess) {
  //     // Call setNickName api and will always pass first element from the sliced data, till it gets empty
  //     const data = _.cloneDeep(this.state.finalSchedules)
  //     data.splice(0, 1)
  //     this.setState({ finalSchedules: data }, () => {
  //       if (data.length === 0) {
  //         // close modal on api success
  //         // this.setState({ showSavedModal: true })
  //         this.setScheduleCall()
  //       } else {
  //         const room = _.first(this.state.finalSchedules)
  //         setSchedule(room)
  //       }
  //     })
  //   }
  //   if (rooms && (rooms.length > 0) && (this.props.rooms !== rooms)) {
  //   // if ((rooms.length > 0) && !setScheduleSuccess) {
  //     // localStorage.setItem('room', roomId)
  //     const obj = defaultSchedule
  //     let newSchedules = []
  //     // Set day of week which are not present inside the rooms schedules
  //     for (let room of rooms) {
  //       let days = []
  //       room.schedules.map(s => days.push(s.dayOfWeek)) // push day of week in a day array to process on all rooms
  //       days = new Set(days)
  //       for(let i = 1; i <= 7; i++) {
  //         // !days.has(i) filter out the existing days and will push only non exists schedules
  //         if(!days.has(i)) newSchedules.push({ ...obj, dayOfWeek: i, id: room.id })
  //       }
  //     }
  //     // Finds the id of the single room having schedules and copy that schedules to the other rooms
  //     const theRoom = rooms.find(room => room.schedules.length)
  //     const currentSchedules = rooms.reduce((roomSchedules, { id, schedules }) => {
  //       // Will copy only when schedule array will be 0 and room id is not equal to id where this schedule exists. 
  //       if(theRoom && id !== _.get(theRoom, 'id', 0) && _.size(schedules) === 0)
  //         roomSchedules.push(...theRoom.schedules.map(schedule => ({ id, ...schedule })))
  //       return roomSchedules
  //     }, [])
  //     // Union both arrays by dayOfWeek and give the priority to the elements from the first array
  //     const finalSchedules = _.unionBy(currentSchedules, newSchedules, o => `${o.id}-${o.dayOfWeek}`)
  //     // _.size(newSchedules) > 0 means no need to copy schedules on other rooms if user is not coming from signup
  //     this.setState({ finalSchedules: _.size(newSchedules) > 0 ? finalSchedules : newSchedules }, () => {
  //       // Api call to the set schedule, passing first element to the api
  //       if (_.first(this.state.finalSchedules)) {
  //         setSchedule(_.first(this.state.finalSchedules))
  //       } else { // Move to home page after saving all the temperature and schedule data as applicable ie on all rooms after signup
  //         this.setScheduleCall()
  //       }
  //     })
  //   } else {
  //     // this.setState({ showError: true })
  //   }
  // }
  componentWillReceiveProps(np) {
    if (np.rooms) {
      if (np.rooms.length > 0) {
        this.props.history.push('/home')
      }
    }
    const { barcodeSuccess, history } = np
    if (barcodeSuccess) {
      if (barcodeSuccess.errors) {
        // setTimeout(() => {
          this.setState({ showError: true, disableNextBtn: false })
        // }, 2000)
      } else {
        // Get first room from the response and store to local storage to manage room value correct while coming from the copy screen
        const roomId = _.get(barcodeSuccess, 'data.assumeControl.rooms[0].id', false)
        if (roomId) {
          localStorage.setItem('room', roomId)
        this.setState({ history, congrats: true, disableNextBtn: false })
        } else {
          this.setState({ showError: true })
        }
      }
    }
  }

  setScheduleCall() {
    history.push('/home')
  }

  navigate() {
    this.setState({ showError: false, showInfo: false, congrats: false }, () => {
      history.push('/home')
    })
  }

  onBarcodeChange(barcode) {
    this.setState({ barcode, error: '' })
  }

  // API call to assumeControl
  onSubmit() {
    const { submitBarcode } = this.props
    if (this.state.barcode !== '' && this.state.barcode.length === 8) {
      this.setState({ disableNextBtn: true }, () => {
        submitBarcode({ barcode: this.state.barcode })
      })
    } else {
      // Handle validation here
      this.setState({ error: "The barcode must be 8 digits. Please try again." })
    }
  }

  // Read bar code from the child component and API call trigger
  barcodeRead(code) {
    if (code !== '' && code.length === 8) {
      this.setState({ barcode: code, startCamera: false, disableNextBtn: true }, () => {
        pinInput(this.state.barcode)
        this.onSubmit()
      })
    }
  }
  // Will be called from child modal component
  closeModal() {
    this.setState({ barcode: this.state.barcode, showError: false, startCamera: true })
  }
  // Will be called from child modal component
  closeInfo() {
    this.setState({ showInfo: false })
  }
  // Will be called from child modal component
  showInfo() {
    this.setState({ showInfo: true })
  }

  render() {
    const { isRoom } = this.props
    return (
      <div>
        {isRoom &&<main id="registerCozy-page">
          <div className="wrapper">
            <header className="header display-flex">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="secondary-title d-block d-md-none">Register Your Cozy</h3>
                    <div className="header-img-box d-none d-md-block">
                      <Link to="/home">
                        <img src="/img/yellow-logo.png" alt="" />
                      </Link>
                      <div className="logo-title">Operated by Radiator Labs</div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="container">
              <div className="row">
                <div className="container-inner">
                  <div className="cozy-slider d-block d-md-none">
                    {isMobile ? <Barcode key="barcode" {...this.props} barcodeRead={this.barcodeRead} startCamera={this.state.startCamera} /> : ''}
                  </div>
                  <div className="col-md-12">
                    <p className="d-block d-md-none">
                      Find the label with the 8-digit code on either the right or left side of any Cozy in your home.
                    </p>
                    <a className="info d-block d-md-none" onClick={this.showInfo}>
                      <img alt="" src="/img/info-icon.svg" /> I can’t find my label.
                    </a>
                    <h2 className="primary-title d-block d-md-none">Scan the barcode</h2>
                    <p className="d-block d-md-none">Hold your phone camera over the barcode to scan.</p>
                    <div className="divider d-block d-md-none">
                      <span className="or">OR</span>
                    </div>
                    <div className="primary-title-info-box">
                      <h2 className="primary-title">Type in barcode</h2>
                      <a className="info" onClick={this.showInfo}>
                        <img alt="" src="/img/info-icon.svg" /> I can’t find my label.
                      </a>
                    </div>
                    <div className="barcode-box">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <img alt="" src="img/barcode_icon.svg" />
                          </span>
                        </div>
                        <ReactCodeInput autoFocus={false} inputMode="false" {...props} value={this.state.barcode} type="text" fields={8} onChange={this.onBarcodeChange} />
                      </div>
                    </div>
                    <p className="error">{this.state.error}</p>
                    <div className="login-signup-link text-center">
                      <span>
                        Need help?{' '}
                        <a rel="noopener noreferrer" href="https://radiatorlabs.zendesk.com/hc/en-us/requests/new" target="_blank">
                          Contact Us
                        </a>
                      </span>
                    </div>
                    <footer>
                      <div className="footer-inner">
                        <div>
                          <button type="button" onClick={this.onSubmit} className="btn btn-primary btn-lg btn-block">
                            {this.state.disableNextBtn ? <div className="loader"></div> : 'Next'}
                          </button>
                        </div>
                      </div>
                    </footer>
                  </div>
                </div>
              </div>
            </div>
            <BarcodeInfoModal modalType="barcodeInfo" open={this.state.showInfo} {...this.props} closeModal={this.closeInfo} />
            <CommonModal key="barcodeSucceed" modalType="barcodeSucceed" open={this.state.congrats} {...this.props} closeModal={this.navigate} />
            <ErrorModal modalType="barcodeError" open={this.state.showError} {...this.props} closeModal={this.closeModal} />
          </div>
        </main>}
      </div>
    )
  }
}
export default RegisterCozy



// WEBPACK FOOTER //
// ./src/views/RegisterCozy/component.js